@import '../../../constants/spacing.module.less';

.recommendation-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: @space-8;
  flex: 1;
  max-width: 386px;
}

.recommendation-savings {
  display: flex;
  align-items: center;
  gap: @space-4;
  flex: 1;
}

.savings-icon {
  width: 16px;
  height: 16px;
  padding: 2px 3.333px 3.333px 2px; // figma icon padding
  color: var(--gold-400);
}

.recommendation-text {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: @space-4;
  color: var(--default--text-color--17);
}

.recommendation-icon {
  height: 16px;
  width: 16px;
  padding: 2px; // figma icon padding
}

.recommendation-name-and-icon {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.apply-button {
  font-size: 12px;
  line-height: 16px;
  height: 24px;
}
